export const messages = {
  title: {
    id: "books-modal.title",
    defaultMessage: "BOOKS OF THE BIBLE",
  },
};
